// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lsn-form-sidebar .panel {
  border: var(--main-border-width) solid var(--main-border-color) !important;
  margin-bottom: 15px;
  border-radius: var(--main-border-radius) !important;
  background-color: var(--main-bg-color-lighter);
}
.lsn-form-sidebar .panel-title {
  padding: 0.5rem 0.7rem 0;
  margin: 0;
}
.lsn-form-sidebar .tile {
  padding: 0.5rem 0.7rem;
}
.lsn-form-sidebar .tile .tile-title {
  padding-bottom: 0.3rem;
}
.lsn-form-sidebar .tile .lsn-text-body {
  font-size: var(--main-font-size-secondary);
}
.lsn-form-sidebar .two-columns {
  display: grid;
  grid-template-columns: 1fr 1fr;
}
.lsn-form-sidebar .lsn-programs-sidebar {
  max-height: 800px;
}
.lsn-form-sidebar .lsn-programs-toggle-button {
  cursor: pointer;
  display: grid;
  grid-template-columns: auto auto 1fr;
  justify-items: end;
  align-items: center;
  padding-bottom: 0;
}
.lsn-form-sidebar .lsn-programs-toggle-button:hover {
  background-color: var(--main-light-gray);
}
.lsn-form-sidebar .lsn-programs-toggle-button .icon {
  color: var(--main-primary-color);
  margin-right: 0.2rem;
}
.lsn-form-sidebar .badge-count {
  margin-left: 0.2rem;
  margin-top: -3px;
  font-style: normal;
}
.lsn-form-sidebar .lsn-sidebar-programs-object {
  max-height: 25rem;
  overflow: hidden;
  overflow-y: auto;
}
.lsn-form-sidebar .lsn-sidebar-programs-object dt {
  font-family: var(--main-font-family-bold);
}
.lsn-form-sidebar .divider {
  margin: 0.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/pages/recommendationForm/FormSidebar/FormSidebar.less"],"names":[],"mappings":"AAAA;EAEI,0EAAA;EACA,mBAAA;EACA,mDAAA;EACA,8CAAA;AAAJ;AALA;EASI,wBAAA;EACA,SAAA;AADJ;AATA;EAcI,sBAAA;AAFJ;AAZA;EAiBM,sBAAA;AAFN;AAfA;EAqBM,0CAAA;AAHN;AAlBA;EA0BI,aAAA;EACA,8BAAA;AALJ;AAtBA;EA+BI,iBAAA;AANJ;AAzBA;EAmCI,eAAA;EACA,aAAA;EACA,oCAAA;EACA,kBAAA;EACA,mBAAA;EACA,iBAAA;AAPJ;AASI;EACE,wCAAA;AAPN;AApCA;EA+CM,gCAAA;EACA,oBAAA;AARN;AAxCA;EAqDI,mBAAA;EACA,gBAAA;EACA,kBAAA;AAVJ;AA7CA;EA2DI,iBAAA;EACA,gBAAA;EACA,gBAAA;AAXJ;AAlDA;EAgEM,yCAAA;AAXN;AArDA;EAqEI,cAAA;AAbJ","sourcesContent":[".lsn-form-sidebar {\n  .panel {\n    border: var(--main-border-width) solid var(--main-border-color) !important;\n    margin-bottom: 15px;\n    border-radius: var(--main-border-radius) !important;\n    background-color: var(--main-bg-color-lighter);\n  }\n\n  .panel-title {\n    padding: .5rem .7rem 0;\n    margin: 0;\n  }\n\n  .tile {\n    padding: .5rem .7rem;\n\n    .tile-title {\n      padding-bottom: .3rem;\n    }\n\n    .lsn-text-body {\n      font-size: var(--main-font-size-secondary);\n    }\n  }\n\n  .two-columns {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n  }\n\n  .lsn-programs-sidebar {\n    max-height: 800px;\n  }\n\n  .lsn-programs-toggle-button {\n    cursor: pointer;\n    display: grid;\n    grid-template-columns: auto auto 1fr;\n    justify-items: end;\n    align-items: center;\n    padding-bottom: 0;\n\n    &:hover {\n      background-color: var(--main-light-gray);\n    }\n\n    .icon {\n      color: var(--main-primary-color);\n      margin-right: .2rem;\n    }\n  }\n\n  .badge-count {\n    margin-left: .2rem;\n    margin-top: -3px;\n    font-style: normal;\n  }\n\n  .lsn-sidebar-programs-object {\n    max-height: 25rem;\n    overflow: hidden;\n    overflow-y: auto;\n\n    dt {\n      font-family: var(--main-font-family-bold);\n    }\n  }\n\n  .divider {\n    margin: .5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
